<template>
  <div class="bggray">
    <app-header />
    <div class="subNav">
      <div class="auto">
        <a v-for="item in productList" :to="{name:'Product',params:{id:item.id}}" target="_blank" :key="item.id">{{item.name}}</a>
        <!-- <a :href="'http://zhaoshang.dzhxx.com.cn'">商家入驻</a> -->
      </div>
    </div>
    <section class="mod-product" v-for="product in productList" :key="product.id">
      <div
        class="auto product-graphic"
        :class="{'productWine':product.priority==1,'productTWO':product.priority==2,'productTHR':product.priority==3}"
      >
      <div class="img">
      </div>
        <div class="graphicText">
          <p class="nameText">{{product.name}}</p>
          <section v-for="item in product.descriptionList" :key="item">
            <p>{{item}}</p>
          </section>
          <div class="priceBox">
            <div>
                <span>
                  <em>{{product.curPrice | amountFormat}}</em>
                  <strong>{{product.curPrice | unitFormat}}/{{product.stockUnit}}</strong>
                </span>
                <del v-if="product.oriPrice!=product.curPrice">
                  <em>{{product.oriPrice | amountFormat}}</em>
                  <strong>{{product.oriPrice | unitFormat}}/{{product.stockUnit}}</strong>
                </del>
                <router-link
                  :to="'/order/confirm/' + product.id+'/'+product.stockUnit"
                >立即购买</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <home-footer />
  </div>
</template>

<script scope>
import AppHeader from "@/components/common/AppHeader.vue";
import HomeFooter from "@/components/common/AppFooter.vue";
// import FloatBar from "@/components/product/FloatBar.vue";

export default {
  data() {
    return {
      productList: []
    };
  },
  computed: {},
  created() {
    document.title = "上海大智慧信息科技网上商城";
  },
   mounted: function() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("/index/v1/web")
        .then(response => {
          if (response.code === 0) {
            this.productList = response.data;
          } else {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    },
    toBannerLinkUrl(linkUrl) {
      if (linkUrl != null && linkUrl != "") {
        window.open(linkUrl);
      }
      return false;
    }
  },
  components: {
    AppHeader,
    // FloatBar,
    HomeFooter
  }
};
</script>

<style>
.el-carousel {
  width: 1260px;
  height: 440px;
  margin: 0 auto;
}
.el-carousel__item img {
  width: 1260px;
  height: 440px;
}
.el-carousel__container .el-carousel__arrow {
  height: 60px;
  width: 60px;
  top: 50%;
  font-size: 30px;
}
</style>
<style lang="scss" scoped>
.img-box{
  margin: 0 auto;
  padding-bottom: 30px;
  img{
    display: block;
    margin: 0 auto;
  }
}
.info{
  width: 790px;
  margin: 15px auto 15px;
  h2{
    font-size: 22px;
    color: #222;
    margin-bottom: 8px;
  }
  ul{
    overflow: hidden;
    li{
      float: left;
      width: 33.33%;
      margin-bottom: 5px;
      font-size: 16px;
      color: #333;
    }
  }
  >p{
    font-size: 16px;
    color: #333;
  }
}
</style>
<style>
.el-carousel {
  width: 1260px;
  height: 440px;
  margin: 0 auto;
}
.el-carousel__item img {
  width: 1260px;
  height: 440px;
}
.el-carousel__container .el-carousel__arrow {
  height: 60px;
  width: 60px;
  top: 50%;
  font-size: 30px;
}
</style>


// WEBPACK FOOTER //
// src/pages/home/Home.vue